import React from 'react';
import MdxImage from '../common_ui/MdxImage';
import * as styles from './ProfileCard.module.css';

interface ProfileCardProps {
  type: 'reviewer' | 'author';
  name: string;
  profile?: string;
  imageUrl: string;
}

// typeに応じたプレフィックスを取得する関数
const getTypePrefix = (type: string): string => {
  const typePrefixMap: Record<string, string> = {
    reviewer: '監修：',
    author: '執筆：',
  };

  return typePrefixMap[type] || '';
};

const ProfileCard: React.FC<ProfileCardProps> = ({
  type,
  name,
  profile,
  imageUrl,
}) => {
  const typePrefix = getTypePrefix(type);

  return (
    <div
      className={styles.card}
      role='complementary'
      aria-labelledby={`profile-name-${name.replace(/\s+/g, '-')}`}
      aria-label={`${typePrefix}${name}のプロフィール情報`}
    >
      <MdxImage
        className={styles.image}
        src={imageUrl}
        alt={`${name}のプロフィール写真`}
        width={60}
        height={60}
      />
      <div className={styles.content}>
        <div
          className={styles.name}
          id={`profile-name-${name.replace(/\s+/g, '-')}`}
        >
          {typePrefix}
          {name}
        </div>
        {profile && (
          <p
            className={styles.profile}
            aria-describedby={`profile-name-${name.replace(/\s+/g, '-')}`}
          >
            {profile}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileCard;
